/* ════════════════════════════════════════════════════════════════
   COLLECTION TEMPLATE — Design B logic (Shopify edition)
   Renders header, filter sidebar, sort bar and product grid from a
   global COLLECTION_DATA injected by Liquid:
     window.COLLECTION_DATA = {
       tc, en, desc,
       products: [{ title, price, was, img, url, tags:[..], available }]
     };
   Parses each product title into name / colour, maps colours to swatch
   hex, and derives Type / Colour / Material filters automatically.
   ════════════════════════════════════════════════════════════════ */
(function(){
  'use strict';
  var D = window.COLLECTION_DATA;
  if (!D || !D.products) return;

  /* ── colour name → swatch hex (official Color Reference) ── */
  var COLOR_MAP = {
    'Dark Concrete':'#6b6660','深灰':'#6b6660','Concrete':'#b6b1a6','淺灰':'#b6b1a6',
    'Wine':'#6e2f35','酒紅':'#6e2f35','Refined Wine':'#6e2f35',
    'Black':'#1f1f1f','黑色':'#1f1f1f','Space Black':'#26262a',
    'Beige':'#d8c8a6','米灰':'#d8c8a6','米白':'#e7dcc2','Sandstone Beige':'#d6c4a0',
    'Lilac':'#b9a6c9','丁香紫':'#b9a6c9',
    'Toffee':'#a86c3a','焦糖啡':'#a86c3a','咖啡':'#6f4a2e',
    'Underwater':'#2f4156','深藍':'#2f4156','The Deep Blue':'#27384f','Cobalt Blue':'#2f4d7a',
    'Hunter':'#3c4a3a','墨綠':'#3c4a3a','Forest Green':'#34503f','Leafy Green':'#5f7050','綠色':'#4a5d44','大地灰':'#9a9384',
    'Baby Powder':'#c6d3dc','粉藍':'#c6d3dc','Baby Pink':'#e6c3c8','粉紅':'#e6c3c8',
    'Nude':'#d8c3a8','裸色':'#d8c3a8','Taupe':'#8a8278','大象灰':'#8a8278','Earthy Taupe':'#8f8170',
    'Smoky Dark Grey':'#4a4a4d','Raven Charcoal':'#3a3a3c','Frost White':'#eceae2','Horizon Light Blue':'#a9c2d2',
    'Sunlit Ochre':'#cf9a4a','Sunset Terra':'#b56a44','Maroon Muse':'#5e2b32','Caramel Toffee':'#a86c3a',
    'Dawn Blush':'#e8c8c0','晨霞':'#e8c8c0','Morning Mist':'#ccd2cf','薄霧':'#ccd2cf',
    'Sakura Whisper':'#edcdd6','櫻語':'#edcdd6','After the Rain':'#aebcc0','雨後':'#aebcc0'
  };
  var FALLBACK = '#bdb6a4';
  // keys longest-first so "Dark Concrete" matches before "Concrete"
  var COLOR_KEYS = Object.keys(COLOR_MAP).sort(function(a,b){ return b.length-a.length; });

  function swatchFor(colour){
    if (!colour) return [];
    var hexes = [], used = {};
    colour.split(/\s*[X×x／/]\s*|\s+配\s*/).forEach(function(seg){
      if (!seg) return;
      for (var i=0;i<COLOR_KEYS.length;i++){
        if (seg.indexOf(COLOR_KEYS[i]) !== -1){
          var h = COLOR_MAP[COLOR_KEYS[i]];
          if (!used[h]){ hexes.push(h); used[h]=1; }
          return;
        }
      }
    });
    if (!hexes.length){
      for (var j=0;j<COLOR_KEYS.length;j++){
        if (colour.indexOf(COLOR_KEYS[j]) !== -1){ hexes.push(COLOR_MAP[COLOR_KEYS[j]]); break; }
      }
    }
    return hexes;
  }

  /* ── standing-ladder pages: every product on these collections carries the
     愈守 multi-buy ladder (2/3/4/6 件 = 9/88/85/85 折), best tier 85折 ── */
  var HEAL_LADDER_PAGE = (function(){
    var m = /\/collections\/([^\/?#]+)/.exec(location.pathname);
    var h = m ? decodeURIComponent(m[1]).toLowerCase() : '';
    return h === 'healkeeper' || h === 'scented-heal-keeper' || h === 'premium-gift-set';
  })();

  /* ── parse a raw product into card data ── */
  function parse(p){
    var title = p.title || '';
    var en = title.split('【')[0].replace(/[【\[].*$/,'').trim();
    var m = title.match(/[【\[]([^】\]]*)[】\]]/);
    var colour = m ? m[1].trim() : '';
    var material = /蘋果|Apple/i.test(title) ? 'apple' : (/意大利羊皮|真皮|羊皮/.test(title) ? 'genuine' : '');
    var tags = [];
    // Badge = the product's CURRENT standing discount (2026-09-01 rework, Yoma:
    // no more NEW). Time-limited wave badges are painted separately by
    // bf-promo.js (Surface 2); here we only surface the permanent multi-buy
    // ladders, highlighting the best tier (低至X折 convention).
    var dealEN = /^\/en(\/|$)/.test(location.pathname);
    var dealLabel = dealEN ? 'UP TO 15% OFF' : '低至85折';
    if (HEAL_LADDER_PAGE) {
      tags.push({label: dealLabel, cls: 'sale'});
    } else {
      (p.tags||[]).forEach(function(t){
        if (t === 'Charm') tags.push({label: dealLabel, cls: 'sale'});
      });
    }
    return { en:en||title, colour:colour, type:en||title, material:material,
             price:p.price, was:p.was, img:p.img, img2:p.img2, url:p.url,
             sw:swatchFor(colour), tags:tags, available:p.available!==false };
  }
  var ITEMS = D.products.map(parse);

  /* ── colour-swatch mode: collapse per-colour products into one card per style ── */
  function buildGroups(items){
    var map={}, order=[];
    items.forEach(function(it){
      var key = it.type || it.en;
      if(!map[key]){ map[key]={ en:it.en, type:it.type, material:it.material, members:[], hexes:[], colours:[] }; order.push(key); }
      var g=map[key]; g.members.push(it);
      var hex=it.sw[0];
      if(hex && g.hexes.indexOf(hex)===-1){ g.hexes.push(hex); g.colours.push({ hex:hex, colour:it.colour, url:it.url }); }
    });
    return order.map(function(key){
      var g=map[key];
      var rep=g.members.filter(function(m){return m.available;})[0] || g.members[0];
      var ps=g.members.map(function(m){return m.price;}).filter(function(n){return typeof n==='number';});
      var minP=ps.length?Math.min.apply(null,ps):rep.price, maxP=ps.length?Math.max.apply(null,ps):rep.price;
      return { en:g.en, colour:'', type:g.type, material:g.material, price:minP, priceVaries:minP!==maxP, was:rep.was,
               img:rep.img, img2:rep.img2, url:rep.url, sw:g.hexes, colours:g.colours, tags:rep.tags,
               available:g.members.some(function(m){return m.available;}), grouped:true };
    });
  }
  var UNITS = D.grouped ? buildGroups(ITEMS) : ITEMS;

  /* ── derive filter lists ── */
  function distinct(arr){ var s=[],seen={}; arr.forEach(function(v){ if(v && !seen[v]){ seen[v]=1; s.push(v); } }); return s; }
  var TYPES = distinct(UNITS.map(function(i){ return i.type; }));
  var SHOW_TYPES = TYPES.length > 1;
  var MATS = distinct(UNITS.map(function(i){ return i.material; }).filter(Boolean));
  var SHOW_MATS = MATS.length > 1;
  var MAT_TC = { apple:'蘋果再造皮革', genuine:'意大利真皮' };
  // colours: distinct hex with a representative name
  var COLORS = [], cseen={};
  UNITS.forEach(function(u){ var list = D.grouped ? u.colours : [{hex:u.sw[0], colour:u.colour}]; list.forEach(function(c){ if(c.hex && !cseen[c.hex]){ cseen[c.hex]=1; COLORS.push({hex:c.hex, name:c.colour||''}); } }); });
  var prices = UNITS.map(function(i){ return i.price; }).filter(function(n){ return typeof n==='number'; });
  var pMin = prices.length ? Math.min.apply(null,prices) : 0;
  var pMax = prices.length ? Math.max.apply(null,prices) : 0;

  var state = { type:'all', material:'all', color:null, sort:'newest' };
  function fmt(n){ return 'HKD ' + Number(n).toLocaleString('en-US'); }
  function count(pred){ return UNITS.filter(pred).length; }
  function typeCt(t){ if(D.grouped){ var u=UNITS.filter(function(x){return x.type===t;})[0]; return u?u.colours.length:0; } return count(function(p){return p.type===t;}); }

  /* ── Header ── */
  var head = document.getElementById('catHead');
  if (head) head.innerHTML =
    '<nav class="catB-crumb"><a href="/">首頁</a><span class="sep">/</span>' +
    '<a href="/collections/all">產品 Shop</a><span class="sep">/</span>' +
    '<span class="cur">' + (D.tc||'') + ' ' + (D.en||'') + '</span></nav>' +
    '<h1>' + (D.tc||'') + (D.en ? '<span class="en">' + D.en + '</span>' : '') + '</h1>' +
    (D.desc ? '<p>' + D.desc + '</p>' : '');

  /* ── Sidebar ── */
  function renderSide(){
    var side = document.getElementById('catSide');
    if (!side) return;
    var html = '<button type="button" class="fside-toggle">篩選 · Filter<span class="ft-car">›</span></button><div class="fside-body">';
    if (SHOW_TYPES){
      html += '<div class="fgroup"><h4>款式 · Type</h4>';
      html += '<div class="fopt' + (state.type==='all'?' on':'') + '" data-type="all"><span class="bx"></span>全部<span class="ct">' + UNITS.length + '</span></div>';
      TYPES.forEach(function(t){
        html += '<div class="fopt' + (state.type===t?' on':'') + '" data-type="' + t + '"><span class="bx"></span>' + t + '<span class="ct">' + typeCt(t) + '</span></div>';
      });
      html += '</div>';
    }
    if (COLORS.length){
      html += '<div class="fgroup"><h4>顏色 · Colour</h4><div class="fswatches">';
      COLORS.forEach(function(c){
        html += '<span class="fsw' + (state.color===c.hex?' on':'') + '" data-color="' + c.hex + '" style="background:' + c.hex + '" title="' + (c.name||'') + '"></span>';
      });
      html += '</div><button class="fclear' + (state.color?' show':'') + '" data-clear="color">清除顏色 ✕</button></div>';
    }
    if (pMax && pMax !== pMin){
      html += '<div class="fgroup"><h4>價格 · Price</h4><div class="frange"><span>' + fmt(pMin) + '</span><span class="bar"></span><span>' + fmt(pMax) + '</span></div></div>';
    }
    if (SHOW_MATS){
      html += '<div class="fgroup"><h4>物料 · Material</h4>';
      html += '<div class="fopt' + (state.material==='all'?' on':'') + '" data-material="all"><span class="bx"></span>全部<span class="ct">' + UNITS.length + '</span></div>';
      MATS.forEach(function(mt){
        html += '<div class="fopt' + (state.material===mt?' on':'') + '" data-material="' + mt + '"><span class="bx"></span>' + (MAT_TC[mt]||mt) + '<span class="ct">' + count(function(p){return p.material===mt;}) + '</span></div>';
      });
      html += '</div>';
    }
    side.innerHTML = html + '</div>';
    var ft=side.querySelector('.fside-toggle'); if(ft) ft.onclick=function(){ side.classList.toggle('f-open'); };
  }

  /* ── Grid ── */
  function visible(){
    var list = UNITS.filter(function(p){
      if (state.type !== 'all' && p.type !== state.type) return false;
      if (state.material !== 'all' && p.material !== state.material) return false;
      if (state.color && p.sw.indexOf(state.color) === -1) return false;
      return true;
    });
    if (state.sort === 'price-asc') list = list.slice().sort(function(a,b){ return a.price-b.price; });
    else if (state.sort === 'price-desc') list = list.slice().sort(function(a,b){ return b.price-a.price; });
    return list;
  }
  function groupCardHtml(p){
    var tags = p.tags.map(function(t){ return '<span class="tg ' + (t.cls||'') + '">' + t.label + '</span>'; }).join('');
    if (!p.available) tags += '<span class="tg">售罄</span>';
    var sw = p.colours.map(function(c){ return '<a class="swo" href="' + c.url + '" style="background:' + c.hex + '" title="' + (c.colour||'') + '" aria-label="' + (c.colour||'') + '"></a>'; }).join('');
    var nc = p.colours.length;
    var price = p.priceVaries
      ? '<span class="pr">' + fmt(p.price) + ' 起</span>'
      : (p.was ? '<span class="pr"><s>' + fmt(p.was) + '</s>' + fmt(p.price) + '</span>' : '<span class="pr">' + fmt(p.price) + '</span>');
    return '<div class="bcard grouped">' +
      '<a class="bcard-link" href="' + p.url + '">' +
        '<span class="im" style="background-image:url(\'' + p.img + '\')">' + (p.img2?'<i class="im2" style="background-image:url(\'' + p.img2 + '\')"></i>':'') + (tags?'<span class="tgs">'+tags+'</span>':'') + '</span>' +
        '<span class="en">' + p.en + '</span>' +
        '<span class="tc">' + nc + ' 色可選 · ' + nc + ' colours</span>' +
      '</a>' +
      '<span class="row"><span class="sw">' + sw + '</span>' + price + '</span>' +
    '</div>';
  }
  function cardHtml(p){
    if (p.grouped) return groupCardHtml(p);
    var tags = p.tags.map(function(t){ return '<span class="tg ' + (t.cls||'') + '">' + t.label + '</span>'; }).join('');
    if (!p.available) tags += '<span class="tg">售罄</span>';
    var sw = p.sw.map(function(c){ return '<i style="background:' + c + '"></i>'; }).join('');
    var price = p.was
      ? '<span class="pr"><s>' + fmt(p.was) + '</s>' + fmt(p.price) + '</span>'
      : '<span class="pr">' + fmt(p.price) + '</span>';
    var primary = p.en, secondary = p.colour;
    if (!SHOW_TYPES && p.colour){ primary = p.colour; secondary = p.en; }
    return '<a class="bcard" href="' + p.url + '">' +
      '<span class="im" style="background-image:url(\'' + p.img + '\')">' + (p.img2?'<i class="im2" style="background-image:url(\'' + p.img2 + '\')"></i>':'') + (tags?'<span class="tgs">'+tags+'</span>':'') + '</span>' +
      '<span class="en">' + primary + '</span>' +
      (secondary ? '<span class="tc">' + secondary + '</span>' : '') +
      '<span class="row"><span class="sw">' + sw + '</span>' + price + '</span>' +
      '</a>';
  }
  function renderGrid(){
    var grid = document.getElementById('catGrid'), cnt = document.getElementById('catCnt');
    if (!grid) return;
    var list = visible();
    var idx=-1; STYLES.forEach(function(st,i){ if(st.h===CUR_HANDLE) idx=i; });
    var nxt = idx>=0 ? STYLES[(idx+1)%STYLES.length] : null;
    var cta = nxt ? '<a class="bcard bcard-cta" href="/collections/'+nxt.h+'"><span class="bc-eyebrow">下一款 · NEXT</span><span class="bc-name">'+nxt.tc+'<i>'+nxt.en+'</i></span><span class="bc-arr">→</span></a>' : '';
    grid.innerHTML = list.length ? (list.map(cardHtml).join('') + cta) : '<p class="bempty">此組合暫時未有作品 — 試吓清除篩選。</p>';
    var unitTxt = D.grouped ? '款式' : '件作品';
    if (cnt) cnt.innerHTML = (state.type==='all' && state.material==='all' && !state.color)
      ? '<b>' + list.length + '</b> ' + unitTxt + ' · Showing all'
      : '<b>' + list.length + '</b> ' + unitTxt + ' · 已篩選';
  }

  /* ── style directory (for more-styles strip + CTA tile) ── */
  var A='/cdn/shop/t/7/assets/';
  var STYLES=[
    {h:'boxy-bag',tc:'盒型袋',en:'Boxy',img:A+'bfb-apbx0410-2q.jpg'},
    {h:'ladder-bag',tc:'梯形袋',en:'Ladder',img:A+'bfb-apld1306-10u.jpg'},
    {h:'square-bag',tc:'方形袋',en:'Square',img:A+'bfb-apsq1208-5v.jpg'},
    {h:'tote-bag',tc:'框形托特',en:'Box Tote XS',img:A+'bfb-apbtsx08-13w.jpg'},
    {h:'harvest-bag',tc:'豐收袋',en:'Harvest',img:'https://cdn.shopify.com/s/files/1/0959/0489/1153/files/bfb-aphv0302-17q-approved-20260930.png?v=1790736023'},
    {h:'mini-hoop',tc:'搓手液套',en:'Mini Hoop',img:A+'bfs-apmh08-1j.jpg'},
    {h:'mini-boxy',tc:'迷你盒仔袋',en:'Mini Boxy',img:A+'bfs-apmbx04-1n.jpg'},
    {h:'id-holder',tc:'證件套',en:'ID Holder',img:A+'bfs-apid02-1h.jpg'},
    {h:'passport-holder',tc:'多格護照套',en:'Passport Holder',img:A+'bfs-appac01-1j.jpg'},
    {h:'passport-case',tc:'護照套',en:'Passport Case',img:A+'bfs-appac07-1p.jpg'},
    {h:'mini-wallet',tc:'迷你銀包',en:'Mini Wallet',img:A+'bfs-apmiw07-1j.jpg'},
    {h:'coinsbag',tc:'散銀包',en:'Coinsbag',img:A+'bfs-apbf02-1h.jpg'},
    {h:'zip-holder',tc:'拉鏈散銀包',en:'Zip Holder',img:A+'bfs-apzh02-1k.jpg'},
    {h:'healink',tc:'愈結孭帶',en:'Healink',img:A+'bfs-aphl45l1206-1l.jpg'},
    {h:'healkeeper',tc:'愈守',en:'Healkeeper',img:'https://cdn.shopify.com/s/files/1/0959/0489/1153/files/Photoroom_20251029_011456_3dd473a9-0c20-4257-8d9f-28ec7efb17a0_600x600.jpg?v=1772463350'},
    {h:'made-to-heal',tc:'小愈結',en:'Heal Charm',img:A+'bfs-aphc-a-1h.jpg'}
  ];
  var CUR_HANDLE=(location.pathname.match(/\/collections\/([^\/?#]+)/)||[])[1]||'';
  try{ CUR_HANDLE=decodeURIComponent(CUR_HANDLE); }catch(e){}
  /* ── Main shell ── */
  var main = document.getElementById('catMain');
  if (main) main.innerHTML =
    '<div class="sortbar"><span class="cnt" id="catCnt"></span>' +
    '<select id="catSort" aria-label="排序"><option value="newest">排序：最新上架</option>' +
    '<option value="price-asc">價格：低至高</option><option value="price-desc">價格：高至低</option></select></div>' +
    '<div class="bgrid" id="catGrid"></div>' +
    '<div id="moreStyles"></div>';

  var ms=document.getElementById('moreStyles');
  if (ms){
    var tiles=STYLES.filter(function(st){ return st.h!==CUR_HANDLE; }).map(function(st){
      return '<a class="ms-tile" href="/collections/'+st.h+'"><span class="ms-img" style="background-image:url(\''+st.img+'\')"></span><span class="ms-tc">'+st.tc+'</span><span class="ms-en">'+st.en+'</span></a>';
    }).join('');
    ms.innerHTML='<h3 class="ms-h">更多款式 · <em>More Styles</em></h3><div class="ms-row">'+tiles+'</div>';
  }

  /* ── Events ── */
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-type]');
    if (t){ state.type = t.getAttribute('data-type'); renderSide(); renderGrid(); return; }
    var m = e.target.closest('[data-material]');
    if (m){ state.material = m.getAttribute('data-material'); renderSide(); renderGrid(); return; }
    var c = e.target.closest('[data-color]');
    if (c){ var hex = c.getAttribute('data-color'); state.color = (state.color===hex? null : hex); renderSide(); renderGrid(); return; }
    var cl = e.target.closest('[data-clear]');
    if (cl){ state.color = null; renderSide(); renderGrid(); return; }
  });
  document.addEventListener('change', function(e){
    if (e.target && e.target.id === 'catSort'){ state.sort = e.target.value; renderGrid(); }
  });

  renderSide();
  renderGrid();
})();
